import { render, staticRenderFns } from "./Oportunity.vue?vue&type=template&id=922a8b3c&"
import script from "./Oportunity.vue?vue&type=script&lang=ts&"
export * from "./Oportunity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports